module.exports = __webpack_public_path__ + "static/media/oberflex-acajouafriquet19-2560x1440.137d8093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-acajouafriquet19-2560x1440.jpg
// module id = 965
// module chunks = 37